import NoteAndDocument from "../../../../../../components/noteAndDocument/NoteAndDocument";
import { InternalTransportNotesSectionProps } from "../internalTransport.types";

const InternalTransportNotesSection = ({
  notesRef,
  parentId,
  disabled
}: InternalTransportNotesSectionProps) => (
  <NoteAndDocument
    parentId={parentId}
    ref={notesRef}
    isDisabled={disabled}
    showSaveButton={false}
  />
);

export default InternalTransportNotesSection;
